export default "__VITE_ASSET__BgCm2GfB__"